import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { useAppSelector } from '../../../redux/store';
import { ActiveBlindTimerDisplay } from './activeBlindTimerDisplay';
import { MttNumTablesDisplayContainer } from './mttNumTablesDisplayContainer';
export const FloatingTourneyHeaderContainer = () => {
    const tableAreaWidth = useAppSelector((state) => state.gameDimensions.tableAreaDimensions?.w);
    const roundSecondsTotal = useAppSelector((state) => state.poker.tourneyProperties?.activeBlindTimer?.roundSecondsTotal);
    const startTimestampSeconds = useAppSelector((state) => state.poker.tourneyProperties?.activeBlindTimer?.startTimestampSeconds);
    const numMttTables = useAppSelector((state) => state.mtt.numMttTables);
    const containerCss = useMemo(() => tableAreaWidth !== undefined
        ? css `
            z-index: 1;
            position: absolute;
            left: 0;
            top: 0;
            width: ${tableAreaWidth}px;
            max-width: 100%;
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            user-select: none;
            align-items: center;
          `
        : undefined, [tableAreaWidth]);
    if (roundSecondsTotal === undefined || startTimestampSeconds === undefined || !containerCss) {
        return null;
    }
    return (_jsxs("div", { css: containerCss, children: [_jsx(ActiveBlindTimerDisplay, { roundSecondsTotal: roundSecondsTotal, startTimestampSeconds: startTimestampSeconds }), numMttTables && _jsx(MttNumTablesDisplayContainer, { numMttTables: numMttTables })] }));
};
